export default {"src":"/encomendas-static/_next/static/media/safePurchase.d809785d.svg","height":35,"width":181,"blurWidth":0,"blurHeight":0};